import React, { useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Box, Flex } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { LiveSessionContext } from "../../../context/LiveSessionContext";
import { PlayerFooter } from "./PlayerFooter";
import { PlayerLobby } from "./PlayerLobby";
import { PlayerCountdown } from "./PlayerCountdown";
import { IVSVideoPlayer } from "./IVSVideoPlayer";
import { VideoJSVideoPlayer } from "./VideoJSVideoPlayer";
import * as VideoPlayerConst from "../../../constants/videoPlayer";
import { config } from "../../../config";

export const PlayerContent = ({ headerHeight, footerHeight, footerRef }) => {
  const { showPlayerLobby } = useContext(LiveSessionContext);
  const [videoHeight, setVideoHeight] = useState("calc(100vh - 0px)");
  const [goLiveButtonDisabled, setGoLiveButtonDisabled] = useState(true);

  useEffect(() => {
    setVideoHeight(`calc(100vh - ${headerHeight + footerHeight}px)`);
  }, [headerHeight, footerHeight]);

  const getPlayerDimensions = () => ({
    width: "100%",
    height: videoHeight,
  });

  /* eslint-disable-next-line react/jsx-props-no-spreading */
  const getPlayerLobby = () => <PlayerLobby {...getPlayerDimensions()} />;

  const getVideoPlayer = () =>
    ({
      [VideoPlayerConst.AWS_IVS]: (
        <IVSVideoPlayer
          /* eslint-disable-next-line react/jsx-props-no-spreading */
          {...getPlayerDimensions()}
          onReady={() => setGoLiveButtonDisabled(false)}
          onEnded={() => setGoLiveButtonDisabled(true)}
          onStreamError={() => setGoLiveButtonDisabled(true)}
        />
      ),
      [VideoPlayerConst.VIDEO_JS]: (
        <VideoJSVideoPlayer
          /* eslint-disable-next-line react/jsx-props-no-spreading */
          {...getPlayerDimensions()}
          onReady={() => setGoLiveButtonDisabled(false)}
          onEnded={() => setGoLiveButtonDisabled(true)}
          onStreamError={() => setGoLiveButtonDisabled(true)}
        />
      ),
    }[config.DEFAULT_VIDEO_PLAYER]);

  const getPlayerContent = () => (showPlayerLobby ? getPlayerLobby() : getVideoPlayer());

  return (
    <Flex flexDirection="column" justifyContent="center" flexGrow={1}>
      <Box position="relative">
        {getPlayerContent()}
        <PlayerCountdown />
      </Box>
      <PlayerFooter footerRef={footerRef} goLiveButtonDisabled={goLiveButtonDisabled} />
    </Flex>
  );
};

PlayerContent.propTypes = {
  headerHeight: PropTypes.number,
  footerHeight: PropTypes.number,
  footerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.elementType }),
  ]),
};

PlayerContent.defaultProps = {
  headerHeight: 0,
  footerHeight: 0,
  footerRef: null,
};

export default PlayerContent;
